/* eslint-disable eqeqeq */
/* eslint-disable max-len */
import React from 'react';
import { useTranslation } from 'react-i18next';

import { regionModel, citiesModel } from '../../../constants';
import { LabeledSelect } from '..';

export const CitiesDropDown = ({ label, id, onChange,
  withAsterisks, region, disabled, value, allCities = false, allowClear }) => {

  const [ t ] = useTranslation();

  const cities = {

    [regionModel.ALBAHAH]: [
      // { value: citiesModel.ALL, text: t('fields.city.all') },
      { value: citiesModel.ALAQIQ, text: t('fields.city.alaqiq') },
      { value: citiesModel.ALBAHA, text: t('fields.city.albaha') },
      { value: citiesModel.ALMANDAQ, text: t('fields.city.almandaq') },
      { value: citiesModel.ALMUKHWA, text: t('fields.city.almukhwa') },
      { value: citiesModel.BALJURASHI, text: t('fields.city.baljurashi') },
      { value: citiesModel.QULWAH, text: t('fields.city.qulwah') }
    ],
    [regionModel.ALJAWF]: [
      // { value: citiesModel.ALL, text: t('fields.city.all') },
      { value: citiesModel.ALQARIYAT, text: t('fields.city.alqariyat') },
      { value: citiesModel.DAWMAT_ALJANDAL, text: t('fields.city.dawmatAljandal') },
      { value: citiesModel.SAKAKA, text: t('fields.city.sakaka') }
    ],
    [regionModel.ALMADINAH]: [
      // { value: citiesModel.ALL, text: t('fields.city.all') },
      { value: citiesModel.ALHANAKIAYH, text: t('fields.city.alhanakiayh') },
      { value: citiesModel.ALMADINAH, text: t('fields.city.almadinah') },
      { value: citiesModel.ALMAHD, text: t('fields.city.almahd') },
      { value: citiesModel.ALOLA, text: t('fields.city.alola') },
      { value: citiesModel.BADR, text: t('fields.city.badr') },
      { value: citiesModel.KHAILBAR, text: t('fields.city.khailbar') },
      { value: citiesModel.YANBU_ALBAHR, text: t('fields.city.yanbuAlbahr') }
    ],
    [regionModel.ALQASSIM]: [
      // { value: citiesModel.ALL, text: t('fields.city.all') },
      { value: citiesModel.ALASYAH, text: t('fields.city.alasyah') },
      { value: citiesModel.ALBADAIA, text: t('fields.city.albadaia') },
      { value: citiesModel.ALBUKIERIYAH, text: t('fields.city.albukieriyah') },
      { value: citiesModel.ALMAZNAB, text: t('fields.city.almaznab') },
      { value: citiesModel.ALNABHANIYAH, text: t('fields.city.alnabhaniyah') },
      { value: citiesModel.ALRASS, text: t('fields.city.alrass') },
      { value: citiesModel.ALSHAMASIYAH, text: t('fields.city.alshamasiyah') },
      { value: citiesModel.BURIEDAH, text: t('fields.city.buriedah') },
      { value: citiesModel.ONIEZAH, text: t('fields.city.oniezah') },
      { value: citiesModel.OYOON_ALJEWAA, text: t('fields.city.oyoonAljewaa') },
      { value: citiesModel.RIYADH_ALKHUBRAA, text: t('fields.city.riyadhAlkhubraa') }
    ],
    [regionModel.ASIR]: [
      // { value: citiesModel.ALL, text: t('fields.city.all') },
      { value: citiesModel.ABHA, text: t('fields.city.abha') },
      { value: citiesModel.AHAD_RUFIEDAH, text: t('fields.city.ahadRufiedah') },
      { value: citiesModel.ALMAJARDAH, text: t('fields.city.almajardah') },
      { value: citiesModel.ALNAMS, text: t('fields.city.alnams') },
      { value: citiesModel.BALQARN, text: t('fields.city.balqarn') },
      { value: citiesModel.BIESHA, text: t('fields.city.biesha') },
      { value: citiesModel.DHAHRAN_ALJANOUB, text: t('fields.city.dhahranAljanoub') },
      { value: citiesModel.KHAMIS_MISHIET, text: t('fields.city.khamisMishiet') },
      { value: citiesModel.MAHAIEL, text: t('fields.city.mahaiel') },
      { value: citiesModel.RIJAL_ALMAA, text: t('fields.city.rijalAlmaa') },
      { value: citiesModel.SURAT_OBIEDAH, text: t('fields.city.suratObiedah') },
      { value: citiesModel.TATHIETH, text: t('fields.city.tathieth') }
    ],
    [regionModel.EASTERN_REGION]: [
      // { value: citiesModel.ALL, text: t('fields.city.all') },
      { value: citiesModel.ABGIG, text: t('fields.city.abgig') },
      { value: citiesModel.ALAHSA, text: t('fields.city.alahsa') },
      { value: citiesModel.ALDAMMAM, text: t('fields.city.aldammam') },
      { value: citiesModel.ALJUBAIL, text: t('fields.city.aljubail') },
      { value: citiesModel.ALKHAFJI, text: t('fields.city.alkhafji') },
      { value: citiesModel.ALKHOBAR, text: t('fields.city.alkhobar') },
      { value: citiesModel.ALNUAEIYAH, text: t('fields.city.alnuaeiyah') },
      { value: citiesModel.ALQATEIF, text: t('fields.city.alqateif') },
      { value: citiesModel.HAFR_ALBATIN, text: t('fields.city.hafrAlbatin') },
      { value: citiesModel.QARIYAT_ALOLIYAH, text: t('fields.city.qariyatAloliyah') },
      { value: citiesModel.RAS_TANNOURA, text: t('fields.city.rasTannoura') }
    ],
    [regionModel.HAIL]: [
      // { value: citiesModel.ALL, text: t('fields.city.all') },
      { value: citiesModel.ALSHANAN, text: t('fields.city.alshanan') },
      { value: citiesModel.BAQAA, text: t('fields.city.baqaa') },
      { value: citiesModel.GHAZALAH, text: t('fields.city.ghazalah') },
      { value: citiesModel.HAIL, text: t('fields.city.hail') }
    ],
    [regionModel.JIZAN]: [
      // { value: citiesModel.ALL, text: t('fields.city.all') },
      { value: citiesModel.ABUARIEESH, text: t('fields.city.abuarieesh') },
      { value: citiesModel.AHD_ALMASARHA, text: t('fields.city.ahdAlmasarha') },
      { value: citiesModel.ALARDHAH, text: t('fields.city.alardhah') },
      { value: citiesModel.ALDAIR, text: t('fields.city.aldair') },
      { value: citiesModel.ALDARB, text: t('fields.city.aldarb') },
      { value: citiesModel.ALHRATH, text: t('fields.city.alhrath') },
      { value: citiesModel.ALIDABI, text: t('fields.city.alidabi') },
      { value: citiesModel.BIESH, text: t('fields.city.biesh') },
      { value: citiesModel.DHAMD, text: t('fields.city.dhamd') },
      { value: citiesModel.FURSAN, text: t('fields.city.fursan') },
      { value: citiesModel.JIZAN, text: t('fields.city.jizan') },
      { value: citiesModel.RAITH, text: t('fields.city.raith') },
      { value: citiesModel.SABIYAA, text: t('fields.city.sabiyaa') },
      { value: citiesModel.SAMTAH, text: t('fields.city.samtah') }
    ],
    [regionModel.MAKKAH]: [
      // { value: citiesModel.ALL, text: t('fields.city.all') },
      { value: citiesModel.ALJAMOUM, text: t('fields.city.aljamoum') },
      { value: citiesModel.ALKAMEL, text: t('fields.city.alkamel') },
      { value: citiesModel.ALKHURMAH, text: t('fields.city.alkhurmah') },
      { value: citiesModel.ALLIETH, text: t('fields.city.allieth') },
      { value: citiesModel.ALQUNFUDAH, text: t('fields.city.alqunfudah') },
      { value: citiesModel.ALTAIEF, text: t('fields.city.altaief') },
      { value: citiesModel.JEDDAH, text: t('fields.city.jeddah') },
      { value: citiesModel.KHULIES, text: t('fields.city.khulies') },
      { value: citiesModel.MAKKAH, text: t('fields.city.makkah') },
      { value: citiesModel.RABIGH, text: t('fields.city.rabigh') },
      { value: citiesModel.RANIYAH, text: t('fields.city.raniyah') },
      { value: citiesModel.TURBAH, text: t('fields.city.turbah') }
    ],
    [regionModel.NAJRAN]: [
      // { value: citiesModel.ALL, text: t('fields.city.all') },
      { value: citiesModel.ALKHARKIR, text: t('fields.city.alkharkir') },
      { value: citiesModel.BADR_ALJANOUB, text: t('fields.city.badrAljanoub') },
      { value: citiesModel.HABOUNA, text: t('fields.city.habouna') },
      { value: citiesModel.KHABASH, text: t('fields.city.khabash') },
      { value: citiesModel.NAJRAN, text: t('fields.city.najran') },
      { value: citiesModel.SHARORAH, text: t('fields.city.sharorah') },
      { value: citiesModel.THAR, text: t('fields.city.thar') },
      { value: citiesModel.YIADMAH, text: t('fields.city.yiadmah') }
    ],
    [regionModel.NORTHERN_BORDERS]: [
      // { value: citiesModel.ALL, text: t('fields.city.all') },
      { value: citiesModel.ARAR, text: t('fields.city.arar') },
      { value: citiesModel.RAFHA, text: t('fields.city.rafha') },
      { value: citiesModel.TRAIF, text: t('fields.city.traif') }
    ],
    [regionModel.RIYADH]: [
      // { value: citiesModel.ALL, text: t('fields.city.all') },
      { value: citiesModel.AFIF, text: t('fields.city.afif') },
      { value: citiesModel.ALAFLAJ, text: t('fields.city.alaflaj') },
      { value: citiesModel.ALDAWDMI, text: t('fields.city.aldawdmi') },
      { value: citiesModel.ALDIRIYAH, text: t('fields.city.aldiriyah') },
      { value: citiesModel.ALGHAT, text: t('fields.city.alghat') },
      { value: citiesModel.ALHARIEQ, text: t('fields.city.alharieq') },
      { value: citiesModel.ALKHARJ, text: t('fields.city.alkharj') },
      { value: citiesModel.ALMAJMAAH, text: t('fields.city.almajmaah') },
      { value: citiesModel.ALMUZAHMIYAH, text: t('fields.city.almuzahmiyah') },
      { value: citiesModel.ALQWIEIYAH, text: t('fields.city.alqwieiyah') },
      { value: citiesModel.ALRIYADH, text: t('fields.city.alriyadh') },
      { value: citiesModel.ALSALIL, text: t('fields.city.alsalil') },
      { value: citiesModel.ALZULFA, text: t('fields.city.alzulfa') },
      { value: citiesModel.DHIRAM, text: t('fields.city.dhiram') },
      { value: citiesModel.HOTAT_BANI_TAMIM, text: t('fields.city.hotatBaniTamim') },
      { value: citiesModel.HURIMILA, text: t('fields.city.hurimila') },
      { value: citiesModel.RAMAMH, text: t('fields.city.ramamh') },
      { value: citiesModel.SHAQRAA, text: t('fields.city.shaqraa') },
      { value: citiesModel.THADIQ, text: t('fields.city.thadiq') },
      { value: citiesModel.WADI_ALDWASIR, text: t('fields.city.wadiAldwasir') }
    ],
    [regionModel.TABUK]: [
      // { value: citiesModel.ALL, text: t('fields.city.all') },
      { value: citiesModel.ALWAJH, text: t('fields.city.alwajh') },
      { value: citiesModel.ALMLAJ, text: t('fields.city.almlaj') },
      { value: citiesModel.DHIBA, text: t('fields.city.dhiba') },
      { value: citiesModel.HAQL, text: t('fields.city.haql') },
      { value: citiesModel.TABUK, text: t('fields.city.tabuk') },
      { value: citiesModel.TAYMA, text: t('fields.city.tayma') }
    ],
    [regionModel.OUTSIDE_KSA]: [
      // { value: citiesModel.ALL, text: t('fields.city.all') },
      { value: citiesModel.OUTSIDE_KSA, text: t('fields.city.outsideKsa') }
    ]
  };

  const getCityById = cityId => {
    for (const [ key, val ] of Object.entries(citiesModel)) {
      // eslint-disable-next-line eqeqeq
      if (val == cityId) {
        if (key.includes('_')) {
          const fixedKey = key.split('_').map((word, index) => (index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())).join('');

          return t(`fields.city.${fixedKey}`);
        }

        return t(`fields.city.${key.toLocaleLowerCase()}`);
      }
    }

    return false;
  };
  const flattenedCities = () => Object.keys(cities).map(city => cities[city]).flat();
  const getCitiesByRegion = () => cities[region];


  return (
    <LabeledSelect
      label={ label }
      id={ id }
      onChange={ onChange }
      showSearch={ true }
      searchDelay={ 2000 }
      options={ allCities ? flattenedCities() : getCitiesByRegion() }
      filterOption={ false }
      EmptyComponent={ t('ERR.noMatchedCity') }
      withAsterisks={ withAsterisks }
      disabled={ disabled }
      allowClear={ allowClear }
      placeholder={ t('fields.choose') }
      value={ value ? getCityById(value) : undefined }
    />
  );
};
